<script>
import FirstSection from '../../company/components/FirstSection.vue';
import SecondSection from '../../company/components/SecondSection.vue';
import CarbonProfile from "./carbonProfile.vue";

export default {
	components: {
		FirstSection,
		SecondSection,
		CarbonProfile,
	},

	data() {
		return {
			tabs: [
				{ key: 'company', text: this.$t('adminPanel.company') },
				{ key: 'carbon', text: this.$t('adminPanel.carbon') },
			],

			selectedTab: 'company',
		}
	},
}
</script>

<template>
	<div class="mini-company-profile">
		<div class="flex-all-centered-row tabs">
			<button v-for="tab in tabs" :key="tab.key"
				@click="() => selectedTab = tab.key"
				:data-selected="selectedTab === tab.key"
			>
				{{ tab.text }}
			</button>
		</div>

		<div v-if="selectedTab === 'company'"
			class="flex-all-centered-col"
		>
			<br>
			<FirstSection :userInfo="$user" :selectedCompanyId="$user.company_id" />
			<SecondSection :selectedCompanyId="$user.company_id" />
		</div>
		<div v-else-if="selectedTab === 'carbon'"
			class="flex-all-centered-col"
		>
			<br>
			<carbon-profile style="align-self: center;" />
		</div>
	</div>
</template>

<style lang='scss' scoped>
.mini-company-profile {
	background-color: whitesmoke;
	border-radius: 1em;
	box-shadow: 0 .25em .5em .1em gray;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;

	padding: 1em;

	> .tabs {
		border-radius: 10em;
		overflow: hidden;
		border: thin solid var(--sustainfinity-navy);
		
		> button {
			flex: 1;
			text-align: center;
			vertical-align: middle;
			border: 0 !important;
			outline: 0 !important;

			&:first-of-type {
				border-right: thin solid var(--sustainfinity-navy);
			}

			&[data-selected=true] {
				background-color: var(--sustainfinity-navy);
				color: whitesmoke;
			}
		}
	}
}
</style>